var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
//@ts-ignore
import dhbrown from '../../../../images/icons/dhbrown.svg';
import TextModule from './modules/textblock';
import ButtonModule from './modules/buttonblock';
import TitleModule from './modules/titlemodule';
import ItemsModule from './modules/itemsblock';
import CoaImage from './modules/imageblock';
import CoaText from './modules/coatext';
import CityItemsModule from './modules/cityitemsblock';
import MoreModule from './modules/moreblock';
import { SmartPostColorFull } from './modules/TypographySpecblocks/SmartPostColorFull';
import { SmartPostWithIcons } from './modules/TypographySpecblocks/SmartPostWithIcons';
import { UploadBlock } from './modules/uploadblock';
import { BeckonText } from './modules/beckontextblock';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { useDispatch } from 'react-redux';
import { LayoutConst } from '../../../../core/modules/layout.module';
import { useGeneralProps } from '../../../../hooks/useGeneralProps';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    min-height: 720px;\n"], ["\n    position: relative;\n    min-height: 720px;\n"])));
var Wrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    padding-left: 0px;\n    padding-right: 0px;\n    background: #BFBFBF;\n    min-height: 720px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transform: ", ";\n    transform-origin: ", ";\n    right: ", ";\n    top: ", ";\n    box-shadow: none;\n    z-index: ", ";\n\n    .guttet-24 {\n        .col-xl-6,\n        .col-lg-6 {\n        padding-left: 12px;\n        padding-right: 12px;\n        }\n    }\n\n    .post_full_colored_style {\n        padding: 0 0 0 14px;\n    }\n\n    .post_with_icons_style {\n        padding: 0 0 0 14px;\n    }\n"], ["\n    position: relative;\n    padding-left: 0px;\n    padding-right: 0px;\n    background: #BFBFBF;\n    min-height: 720px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transform: ", ";\n    transform-origin: ", ";\n    right: ", ";\n    top: ", ";\n    box-shadow: none;\n    z-index: ", ";\n\n    .guttet-24 {\n        .col-xl-6,\n        .col-lg-6 {\n        padding-left: 12px;\n        padding-right: 12px;\n        }\n    }\n\n    .post_full_colored_style {\n        padding: 0 0 0 14px;\n    }\n\n    .post_with_icons_style {\n        padding: 0 0 0 14px;\n    }\n"])), function (props) {
    return props.isDragging ? 'scale(0.4) rotate(10deg)' : 'scale(1)';
}, function (props) { return (props.isDragging ? 'left top' : 'center'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '2' : '4'); });
var TextItem = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: #BFBFBF;\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 25px;\n    line-height: 40px;\n    color: #151514;\n    padding-top: ", ";\n    position: relative;\n    padding-left: ", ";\n    padding-right: ", ";\n    // padding-bottom: 36px;\n    border: ", ";\n        @media (max-width: ", "px) {\n            padding-left: 10px;\n            padding-right: 10px;\n            font-size: 22px;\n            line-height: 28px;\n            font-weight: 500;\n        }\n"], ["\n    background: #BFBFBF;\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 25px;\n    line-height: 40px;\n    color: #151514;\n    padding-top: ", ";\n    position: relative;\n    padding-left: ", ";\n    padding-right: ", ";\n    // padding-bottom: 36px;\n    border: ", ";\n        @media (max-width: ", "px) {\n            padding-left: 10px;\n            padding-right: 10px;\n            font-size: 22px;\n            line-height: 28px;\n            font-weight: 500;\n        }\n"])), function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'beckonblock'
            ? '0px'
            : props.type === 'postFullColored'
                ? '0px'
                : props.type === 'postWithIcons'
                    ? '0px'
                    : '48px';
}, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.colorStyle === 'light' ? '1px solid rgba(0,0,0,0.3)' : 'none';
}, LayoutConst.screen.s);
var TitleDrag = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    width: 14px;\n    height: 23px;\n    cursor: move;\n    top: 16px;\n    left: 16px;\n    background: url(", ") no-repeat center;\n    z-index: 9;\n    transition: 0.2s;\n    opacity: 0.31;\n\n    &:hover {\n        opacity: 1;\n    }\n"], ["\n    position: absolute;\n    width: 14px;\n    height: 23px;\n    cursor: move;\n    top: 16px;\n    left: 16px;\n    background: url(", ") no-repeat center;\n    z-index: 9;\n    transition: 0.2s;\n    opacity: 0.31;\n\n    &:hover {\n        opacity: 1;\n    }\n"])), dhbrown);
var BeckonBlock = function (props) {
    var blockEls = props.blockEls, type = props.type, isDragging = props.isDragging, dragHandleProps = props.dragHandleProps, colorStyle = props.colorStyle, post = props.post;
    var longreadId = (post || {}).longreadId;
    var generalProps = useGeneralProps();
    var filteredTitle = blockEls.filter(function (item) { return item.typeElement === 'Title'; });
    var dispatch = useDispatch();
    var modulesGen = useMemo(function () { return (blockEls === null || blockEls === void 0 ? void 0 : blockEls.length)
        ? blockEls.map(function (item, i) {
            if (item.typeElement === 'Text') {
                return React.createElement(BeckonText, { key: i, textParameters: item.text });
            }
            if (item.typeElement === 'Button') {
                return React.createElement(ButtonModule, { key: i, textParameters: item.text });
            }
            if (item.typeElement === 'items') {
                return React.createElement(ItemsModule, { key: i, items: item.items });
            }
            if (item.typeElement === 'Image') {
                return React.createElement(CoaImage, { key: i, imageSrc: item.image.urlImage });
            }
            if (item.typeElement === 'TextBigBold') {
                return React.createElement(CoaText, { key: i, name: item.text.textObject.name });
            }
            if (item.typeElement === 'cityitems') {
                return React.createElement(CityItemsModule, { key: i, items: item.items });
            }
            if (item.typeElement === 'readmoreitems') {
                return React.createElement(MoreModule, { key: i, items: item.items });
            }
            if (item.typeElement === 'postFullColored') {
                return React.createElement(SmartPostColorFull, { key: i, items: item.items });
            }
            if (item.typeElement === 'postWithIcons') {
                return (React.createElement(SmartPostWithIcons, { key: i, items: item.items, title: item.text.textObject.name }));
            }
        }) : undefined; }, [blockEls]);
    var onImageUploaded = useCallback(function (result) {
        var _a;
        var userid = localStorage.getItem('userId');
        var imageUrl = (_a = result === null || result === void 0 ? void 0 : result.successful[0]) === null || _a === void 0 ? void 0 : _a.uploadURL;
        var urlArr = imageUrl.split('/');
        var lngh = urlArr.length - 1;
        var imageid = urlArr[urlArr.length - 1];
        dispatch(addLongReadPost({
            id: userid,
            title: '',
            text: '',
            color: 'white',
            imageid: imageid,
            lgid: longreadId,
            generalProps: generalProps,
            isFL: false,
            imgCaption: '',
            style: 'image',
            num: (post === null || post === void 0 ? void 0 : post.position) || 0,
            imageData: imageUrl
        }));
    }, [longreadId, generalProps]);
    return React.createElement(Container, { className: "spec-beckon-block-container" },
        React.createElement(Wrap, { isDragging: isDragging },
            React.createElement(TitleDrag, __assign({}, dragHandleProps, { className: 'handle__toogle' })),
            React.createElement(UploadBlock, { onComplete: onImageUploaded }),
            React.createElement(TextItem, { colorStyle: colorStyle, type: type, className: "spec-beckon-block-text-item" },
                React.createElement("div", { className: "row\n                        ".concat(type === 'coa' ? 'align-items-center' : '', "\n                        ").concat(type === 'readmoreblock' ? 'guttet-24' : '', "\n                        ").concat(type === 'postFullColored'
                        ? 'post_full_colored_style'
                        : '', "\n                        ").concat(type === 'postWithIcons'
                        ? 'post_with_icons_style'
                        : '', "\n                    ") }, modulesGen))));
};
export default BeckonBlock;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=beckonBlock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
//@ts-ignore
import dhbrown from '../../../../images/icons/dhbrown.svg';
import TextModule from './modules/textblock';
import ButtonModule from './modules/buttonblock';
import TitleModule from './modules/titlemodule';
import ItemsModule from './modules/itemsblock';
import CoaImage from './modules/imageblock';
import CoaText from './modules/coatext';
import CityItemsModule from './modules/cityitemsblock';
import MoreModule from './modules/moreblock';
import { SmartPostColorFull } from './modules/TypographySpecblocks/SmartPostColorFull';
import { SmartPostWithIcons } from './modules/TypographySpecblocks/SmartPostWithIcons';
import { UploadBlock } from './modules/uploadblock';
import { BeckonText } from './modules/beckontextblock';
import { addLongReadPost } from '../../../../actions/addLongReadPost';
import { useDispatch } from 'react-redux';
import { LayoutConst } from '../../../../core/modules/layout.module';
import { useGeneralProps } from '../../../../hooks/useGeneralProps';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    min-height: 720px;\n"], ["\n    position: relative;\n    min-height: 720px;\n"])));
var Wrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    padding-left: 0px;\n    padding-right: 0px;\n    background: #BFBFBF;\n    min-height: 720px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transform: ", ";\n    transform-origin: ", ";\n    right: ", ";\n    top: ", ";\n    box-shadow: none;\n    z-index: ", ";\n\n    .guttet-24 {\n        .col-xl-6,\n        .col-lg-6 {\n        padding-left: 12px;\n        padding-right: 12px;\n        }\n    }\n\n    .post_full_colored_style {\n        padding: 0 0 0 14px;\n    }\n\n    .post_with_icons_style {\n        padding: 0 0 0 14px;\n    }\n"], ["\n    position: relative;\n    padding-left: 0px;\n    padding-right: 0px;\n    background: #BFBFBF;\n    min-height: 720px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transform: ", ";\n    transform-origin: ", ";\n    right: ", ";\n    top: ", ";\n    box-shadow: none;\n    z-index: ", ";\n\n    .guttet-24 {\n        .col-xl-6,\n        .col-lg-6 {\n        padding-left: 12px;\n        padding-right: 12px;\n        }\n    }\n\n    .post_full_colored_style {\n        padding: 0 0 0 14px;\n    }\n\n    .post_with_icons_style {\n        padding: 0 0 0 14px;\n    }\n"])), function (props) {
    return props.isDragging ? 'scale(0.4) rotate(10deg)' : 'scale(1)';
}, function (props) { return (props.isDragging ? 'left top' : 'center'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '0' : '0'); }, function (props) { return (props.isDragging ? '2' : '4'); });
var TextItem = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: #BFBFBF;\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 25px;\n    line-height: 40px;\n    color: #151514;\n    padding-top: ", ";\n    position: relative;\n    padding-left: ", ";\n    padding-right: ", ";\n    // padding-bottom: 36px;\n    border: ", ";\n        @media (max-width: ", "px) {\n            padding-left: 10px;\n            padding-right: 10px;\n            font-size: 22px;\n            line-height: 28px;\n            font-weight: 500;\n        }\n"], ["\n    background: #BFBFBF;\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 25px;\n    line-height: 40px;\n    color: #151514;\n    padding-top: ", ";\n    position: relative;\n    padding-left: ", ";\n    padding-right: ", ";\n    // padding-bottom: 36px;\n    border: ", ";\n        @media (max-width: ", "px) {\n            padding-left: 10px;\n            padding-right: 10px;\n            font-size: 22px;\n            line-height: 28px;\n            font-weight: 500;\n        }\n"])), function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'beckonblock'
            ? '0px'
            : props.type === 'postFullColored'
                ? '0px'
                : props.type === 'postWithIcons'
                    ? '0px'
                    : '48px';
}, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.type === 'readmoreblock'
        ? '0px'
        : props.type === 'postFullColored'
            ? '0px'
            : props.type === 'postWithIcons'
                ? '0px'
                : '48px';
}, function (props) {
    return props.colorStyle === 'light' ? '1px solid rgba(0,0,0,0.3)' : 'none';
}, LayoutConst.screen.s);
var TitleDrag = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    width: 14px;\n    height: 23px;\n    cursor: move;\n    top: 16px;\n    left: 16px;\n    background: url(", ") no-repeat center;\n    z-index: 9;\n    transition: 0.2s;\n    opacity: 0.31;\n\n    &:hover {\n        opacity: 1;\n    }\n"], ["\n    position: absolute;\n    width: 14px;\n    height: 23px;\n    cursor: move;\n    top: 16px;\n    left: 16px;\n    background: url(", ") no-repeat center;\n    z-index: 9;\n    transition: 0.2s;\n    opacity: 0.31;\n\n    &:hover {\n        opacity: 1;\n    }\n"])), dhbrown);
var BeckonBlock = function (props) {
    var blockEls = props.blockEls, type = props.type, isDragging = props.isDragging, dragHandleProps = props.dragHandleProps, colorStyle = props.colorStyle, post = props.post;
    var longreadId = (post || {}).longreadId;
    var generalProps = useGeneralProps();
    var filteredTitle = blockEls.filter(function (item) { return item.typeElement === 'Title'; });
    var dispatch = useDispatch();
    var modulesGen = useMemo(function () { return (blockEls === null || blockEls === void 0 ? void 0 : blockEls.length)
        ? blockEls.map(function (item, i) {
            if (item.typeElement === 'Text') {
                return React.createElement(BeckonText, { key: i, textParameters: item.text });
            }
            if (item.typeElement === 'Button') {
                return React.createElement(ButtonModule, { key: i, textParameters: item.text });
            }
            if (item.typeElement === 'items') {
                return React.createElement(ItemsModule, { key: i, items: item.items });
            }
            if (item.typeElement === 'Image') {
                return React.createElement(CoaImage, { key: i, imageSrc: item.image.urlImage });
            }
            if (item.typeElement === 'TextBigBold') {
                return React.createElement(CoaText, { key: i, name: item.text.textObject.name });
            }
            if (item.typeElement === 'cityitems') {
                return React.createElement(CityItemsModule, { key: i, items: item.items });
            }
            if (item.typeElement === 'readmoreitems') {
                return React.createElement(MoreModule, { key: i, items: item.items });
            }
            if (item.typeElement === 'postFullColored') {
                return React.createElement(SmartPostColorFull, { key: i, items: item.items });
            }
            if (item.typeElement === 'postWithIcons') {
                return (React.createElement(SmartPostWithIcons, { key: i, items: item.items, title: item.text.textObject.name }));
            }
        }) : undefined; }, [blockEls]);
    var onImageUploaded = useCallback(function (result) {
        var _a;
        var userid = localStorage.getItem('userId');
        var imageUrl = (_a = result === null || result === void 0 ? void 0 : result.successful[0]) === null || _a === void 0 ? void 0 : _a.uploadURL;
        var urlArr = imageUrl.split('/');
        var lngh = urlArr.length - 1;
        var imageid = urlArr[urlArr.length - 1];
        dispatch(addLongReadPost({
            id: userid,
            title: '',
            text: '',
            color: 'white',
            imageid: imageid,
            lgid: longreadId,
            generalProps: generalProps,
            isFL: false,
            imgCaption: '',
            style: 'image',
            num: (post === null || post === void 0 ? void 0 : post.position) || 0,
            imageData: imageUrl
        }));
    }, [longreadId, generalProps]);
    return React.createElement(Container, { className: "spec-beckon-block-container" },
        React.createElement(Wrap, { isDragging: isDragging },
            React.createElement(TitleDrag, __assign({}, dragHandleProps, { className: 'handle__toogle' })),
            React.createElement(UploadBlock, { onComplete: onImageUploaded }),
            React.createElement(TextItem, { colorStyle: colorStyle, type: type, className: "spec-beckon-block-text-item" },
                React.createElement("div", { className: "row\n                        ".concat(type === 'coa' ? 'align-items-center' : '', "\n                        ").concat(type === 'readmoreblock' ? 'guttet-24' : '', "\n                        ").concat(type === 'postFullColored'
                        ? 'post_full_colored_style'
                        : '', "\n                        ").concat(type === 'postWithIcons'
                        ? 'post_with_icons_style'
                        : '', "\n                    ") }, modulesGen))));
};
export default BeckonBlock;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=beckonBlock.js.map